import {
  getOrEmptyObject,
  createSelectorOrNull,
  createErrorSelector,
  createIsRequestingSelector,
  createSubStateSelector
} from '../../utils/selectors'

import { REDUCER_KEY } from './reducer'

export const selectIntlState = getOrEmptyObject(REDUCER_KEY)

export const isIntlRequesting = createIsRequestingSelector(selectIntlState)()
export const selectIntlError = createErrorSelector(selectIntlState)()
export const selectIntlLocale = createSelectorOrNull(selectIntlState)('locale')
export const selectIntlMessages = createSubStateSelector('messages', selectIntlState)
export const selectIntlFormats = createSubStateSelector('formats', selectIntlState)
